import React, { useEffect, useRef, useState } from "react";
import "./blacklist.style.scss";

import moment from "jalali-moment";
import { Calendar } from "react-modern-calendar-datepicker";
import useOnBlur from "../../../util/useOnBlue";
import { Button, Card, Input, Select, Switch } from "antd";
import { get, post, responseValidator } from "../../../api";
import { toast } from "react-toastify";
import Loading from "../../../loading/loading.index";
import CircularProgress from "@material-ui/core/CircularProgress";
import { is } from "redux-saga/utils";


export default function CEBlackList()
{
    const { Option } = Select;

    const [blackListInfo, setBlackListInfo] = useState({
        id: 0,
        type: 0,
        value: '',
        description: ''
    });

    const [selectedType, setSelectedType] = useState('')

    const [loading, setLoading] = useState(false);
    const [submitloading, setSubmitLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const blackItemTypesTitles = [{ id: 1, title: 'کد ملی' },
    { id: 2, title: 'شماره کارت' },
    { id: 3, title: 'شماره شبا' }, {
        id: 4,
        title: 'تی ایکس آیدی'
    }]


    useEffect(() =>
    {
        if (window.location.pathname.split("/").length > 4)
        {
            setLoading(true);
            setIsEdit(true);
            get(`/BlackList/Get/${window.location.pathname.split("/")[4]}`).then(
                res =>
                {
                    setLoading(false);
                    if (responseValidator(res.status))
                    {
                        setBlackListInfo(res.data.data)
                        setSelectedType(blackItemTypesTitles.filter(s => s.id === res.data.data.type)[0])
                    }
                }
            );
        }
    }, []);
    // 0:not open , 1:open , 2:closed

    function submitHandler()
    {
        setSubmitLoading(true);
        if (!isEdit)
        {
            post("/BlackList/Create", {
                type: blackListInfo.type,
                value: blackListInfo.value,
                description: blackListInfo.description
            }).then(res =>
            {
                setSubmitLoading(false);
                if (responseValidator(res.status))
                {
                    toast.success(res.data.message);
                    setTimeout(
                        () => window.location.replace("/adminpanel/blacklistmanagement"),
                        2000
                    );
                } else toast.error(res.data.message);
            });
        } else
        {

            post("/BlackList/Update", {
                id: blackListInfo.id,
                type: blackListInfo.type,
                value: blackListInfo.value,
                description: blackListInfo.description
            }).then(res =>
            {
                setSubmitLoading(false);
                if (responseValidator(res.status))
                {
                    toast.success(res.data.message);
                    setTimeout(
                        () => window.location.replace("/adminpanel/blacklistmanagement"),
                        2000
                    );
                } else toast.error(res.data.message);
            });
        }
    }

    return (
        <div className="temx-blacklist-management-blacklist">
            {loading && <Loading />}
            <Card style={{ paddingLeft: "-38px" }} title="اطلاعات بلک آیتم">
                <div className="my-row">
                    <div className="items">
                        <label>مقدار*</label>
                        <Input
                            value={blackListInfo.value}
                            onChange={e => setBlackListInfo({ ...blackListInfo, value: e.target.value })}
                            type="email"
                            placeholder="مقدار را وارد کنید"
                        />
                    </div>

                    {
                        !isEdit &&

                        <div className="items">
                            <label>نوع*</label>
                            <Select
                                defaultValue={selectedType.title}
                                placeholder="نوع بلک آیتم را انتخاب کنید"
                                onChange={e => setBlackListInfo({ ...blackListInfo, type: e })}
                            >
                                {
                                    blackItemTypesTitles.map((item) =>
                                    {
                                        return <Option value={item.id}>{item.title}</Option>
                                    })
                                }

                            </Select>

                        </div>
                    }
                    <div className="items">
                        <label>توضیحات</label>
                        <Input.TextArea
                            value={blackListInfo.description}
                            onChange={e => setBlackListInfo({ ...blackListInfo, description: e.target.value })}
                            placeholder="توضحیات در صورت نیاز وارد شود."
                            className="item"
                        />
                    </div>
                </div>




                <div className="my-btn">
                    <span />
                    <Button
                        className="my-real-btn"
                        disabled={
                            blackListInfo.value === '' ||
                            blackListInfo.type === 0
                        }
                        onClick={submitHandler}
                        type={"primary"}
                        loading={submitloading}
                    >
                        {!isEdit ? (
                            "ساخت بلک آیتم"
                        ) : (
                            "ویرایش بلک آیتم"
                        )}
                    </Button>
                </div>
            </Card>
        </div>
    );
}
